import { render, staticRenderFns } from "./Topic0LookupPanel.vue?vue&type=template&id=49935535&scoped=true"
import script from "./Topic0LookupPanel.vue?vue&type=script&lang=ts"
export * from "./Topic0LookupPanel.vue?vue&type=script&lang=ts"
import style0 from "./Topic0LookupPanel.vue?vue&type=style&index=0&id=49935535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49935535",
  null
  
)

export default component.exports